import { ClassNames } from '../../Util/ClassNames'
import './DotNav.scss'
export function DotNav(props:{length:number, selectedIndex:number, onClick:Function}){
    function Dot(props:{index:number, selectedIndex:number, onClick:Function}){
        const getDotClassNames = () => {
            const classNames:ClassNames = new ClassNames(['dot'])
            if(props.index === props.selectedIndex){
                classNames.addClass('selected')
            }
            return classNames.toString()
        }  
        const onClick = () => {
            props.onClick(props.index)
        } 
        return(
            <div onClick={onClick} className={getDotClassNames()}></div>
        )
    }
    const getDots = () => {
        const dots:JSX.Element[] = []
        for(let i = 0; i < props.length; i++){
            dots.push(<Dot key={i} index={i} selectedIndex={props.selectedIndex} onClick={props.onClick}/>)
        }
        return dots
    }
    return(
        <div className={'dot-nav'}>
            {getDots()}
        </div>
    )
}